(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAmenityTemplateAddToReservation',
	};

	var form_id = 'reservationamenitytemplateaddtoreservation-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var vendor_id            = $('#' + form_id + 'vendor_id').val();
		var $amenities_container = $('.reservation-amenities');

		// typeahead to select a reservation
		Adzuki.Typeahead(
			$('#' + form_id + 'reservation_search'),
			function source(term, display, $self) {
				var url = '/Reservations/searchReservations/' + term;

				if (vendor_id) {
					url += '/0/' + vendor_id;
				}

				$self.removeClass('ajax-spinner');
				Adzuki.Ajax.get(url).then(function _reservationSearch(response) {
					$self.removeClass('ajax-spinner');
					display(response);
				});
			},
			function onSelect(reservation, $self, typeahead) {
				$self.prop('disabled', true);
				$('#' + form_id + 'reservation_vendor_id').val(reservation.reservation_vendor_id);
				$('.reset-reservation-typeahead').removeClass('hidden');

				displayExistingAmenities($amenities_container, reservation.reservation_vendor_id);
			}
		);

		// if the vendor booking is pre-selected, display any existing amenities for it
		if ($('#' + form_id + 'reservation_vendor_id').val()) {
			displayExistingAmenities(
				$amenities_container,
				$('#' + form_id + 'reservation_vendor_id').val()
			);
		}

		// button to reset the selected reservation
		$('.reset-reservation-typeahead').on('click', function _onClickResetTypeahead(e)
		{
			e.preventDefault();

			// hide reset button and reset typeahead fields
			$('.reset-reservation-typeahead').addClass('hidden');
			$('#' + form_id + 'reservation_search').prop('disabled', false);
			$('#' + form_id + 'reservation_search').val('');
			$('#' + form_id + 'reservation_vendor_id').val('');

			// hide any existing amenities
			$amenities_container.html('').addClass('hidden');
		});
	};

	function displayExistingAmenities($amenities_container, reservation_vendor_id)
	{
		if (!reservation_vendor_id) {
			return;
		}

		$amenities_container.html('').addClass('hidden');

		// display any existing amenities in the reservation
		Adzuki.Ajax.get('/ReservationAmenities/getAmenities/' + reservation_vendor_id)
			.then(function _getAmenities(response) {
				$amenities_container.removeClass('hidden').html(response);
			});
	}
}(jQuery, window.Adzuki || {}));
